import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentSwaps = ({ swaps }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-foreground mb-1">Recent Swaps</h3>
          <p className="text-sm text-muted-foreground">Your swap transaction history</p>
        </div>
        <button className="text-sm text-primary hover:underline">
          View All
        </button>
      </div>

      <div className="space-y-4">
        {swaps?.map((swap) => (
          <div 
            key={swap?.id} 
            className="p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-smooth cursor-pointer"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center">
                  <Icon name="RefreshCw" size={18} className="text-accent" />
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-foreground">{swap?.fromAsset}</span>
                    <Icon name="ArrowRight" size={14} className="text-muted-foreground" />
                    <span className="text-sm font-semibold text-foreground">{swap?.toAsset}</span>
                  </div>
                  <p className="text-xs text-muted-foreground">{swap?.timestamp}</p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div className="w-2 h-2 rounded-full bg-success" />
                <span className="text-xs text-muted-foreground capitalize">{swap?.status}</span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p className="text-xs text-muted-foreground mb-1">From</p>
                <p className="font-medium text-foreground">
                  {swap?.fromAmount} {swap?.fromAsset}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">To</p>
                <p className="font-medium text-foreground">
                  {swap?.toAmount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {swap?.toAsset}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Rate</p>
                <p className="font-medium text-foreground">
                  {swap?.rate?.toLocaleString('en-US', { maximumFractionDigits: 2 })}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Fee</p>
                <p className="font-medium text-foreground">${swap?.fee}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentSwaps;